import api from "../../../config/axios/configAxios";

export const getNotifications = async () =>
  api.get(`/api/Notifications`);

export const getSendNotifications = async (userId: string) =>
  api.get(`/api/Notifications/sent?OrderBy=SentDate&Desc=true&userId=${userId}`);
